import { withPrefetch } from '../../../../../../components/hocs';
import { prefetchCustomersOverviews } from '../../../../../../hooks/requests/use-customers-overviews/use-customers-overviews';
import { CreateContractFormContainer } from '../../../containers/CreateContractFormContainer';

type CreateContractDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  cloneFromPlanId?: string;
  initialCustomerId?: string;
  label?: string;
  labelDescription?: string;
};

const CreateContractDialog: React.FC<CreateContractDialogProps> = ({
  isOpen,
  onClose,
  initialCustomerId,
  cloneFromPlanId,
  label = 'Create a new contract',
  labelDescription = 'Assign a pricing plan to a customer and select a starting date',
}) => {
  return (
    <CreateContractFormContainer
      isOpen={isOpen}
      onClose={onClose}
      initialCustomerId={initialCustomerId}
      cloneFromPlanId={cloneFromPlanId}
      label={label}
      labelDescription={labelDescription}
    />
  );
};

// TODO: ENG-2959 Update to use new prefetch function
const CreateContractDialogWithPrefetch = withPrefetch(CreateContractDialog, prefetchCustomersOverviews);

export { CreateContractDialogWithPrefetch as CreateContractDialog };
